module.exports = __webpack_public_path__ + "img/bird.25f9bbb8.jpg";